import styled from 'styled-components/macro';
import { ReactComponent as AnimalPrintIcon } from '../../../assets/svg/other_avatar.svg';

const AnimalPrint = styled(AnimalPrintIcon)``;

export default AnimalPrint;
